var $54b47fc030b7b21e$exports = {};
// Burger Menu _____________________________
var $54b47fc030b7b21e$var$burger = document.querySelector(".menu-burger");
var $54b47fc030b7b21e$var$menu = document.querySelector(".menu");
function $54b47fc030b7b21e$var$toggleMenu() {
    $54b47fc030b7b21e$var$menu.classList.toggle("is-active");
}
$54b47fc030b7b21e$var$burger.addEventListener("click", $54b47fc030b7b21e$var$toggleMenu);
// Light/Dark mode___________________________
// desktop
const $54b47fc030b7b21e$var$toggleDarkModeBtn = document.querySelector("#dark-mode-btn");
const $54b47fc030b7b21e$var$toggleLightModeBtn = document.querySelector("#light-mode-btn");
$54b47fc030b7b21e$var$toggleDarkModeBtn.addEventListener("click", function() {
    document.querySelector("html").setAttribute("data-theme", "dark");
});
$54b47fc030b7b21e$var$toggleLightModeBtn.addEventListener("click", function() {
    document.querySelector("html").setAttribute("data-theme", "light");
});
// mobile
const $54b47fc030b7b21e$var$toggleDarkModeBtnMobile = document.querySelector("#dark-mode-btn-mobile");
const $54b47fc030b7b21e$var$toggleLightModeBtnMobile = document.querySelector("#light-mode-btn-mobile");
$54b47fc030b7b21e$var$toggleDarkModeBtnMobile.addEventListener("click", function() {
    document.querySelector("html").setAttribute("data-theme", "dark");
});
$54b47fc030b7b21e$var$toggleLightModeBtnMobile.addEventListener("click", function() {
    document.querySelector("html").setAttribute("data-theme", "light");
});
// Filters____________________________________
const $54b47fc030b7b21e$var$cards = document.querySelectorAll(".god-card");
const $54b47fc030b7b21e$var$filters = document.querySelectorAll("input[name='type']");
$54b47fc030b7b21e$var$filters.forEach((filter)=>{
    filter.addEventListener("click", function() {
        const value = filter.value; // Récupère la valeur du filtre cliqué
        $54b47fc030b7b21e$var$cards.forEach((card)=>{
            const type = card.getAttribute("data-type"); // Récupère la catégorie de la carte
            if (type === value) card.classList.remove("hide"); // Montrer
            else card.classList.add("hide"); // Cacher
        });
    });
});


//# sourceMappingURL=index.7b916c86.js.map
